import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)
	const ex1 = await getThemePic(data?.customTheme, 'ex-1')
	const ex2 = await getThemePic(data?.customTheme, 'ex-2')
	const ex3 = await getThemePic(data?.customTheme, 'ex-3')
	const ex4 = await getThemePic(data?.customTheme, 'ex-4')

	return {
		"id": id,
		"elements": [
			{
				"type": "image",
				"id": "6U4YLLytgi",
				"src": ex1,
				"width": 1000,
				"height": 562.5,
				"left": 0,
				"top": 0,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "23iy1FLWjp",
				"src": ex2,
				"width": 909.05,
				"height": 495.68,
				"left": 45.48,
				"top": 33.41,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "k8AKVCLyTX",
				"src": ex3,
				"width": 181.44,
				"height": 22.47,
				"left": 606.82,
				"top": 66.39,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "eKnUD9Qpu-",
				"src": ex4,
				"width": 391.12,
				"height": 338.97,
				"left": -2.98,
				"top": 204.4,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "text",
				"id": "qVRjJjeqMj",
				"width": 126.51,
				"height": 44.21875,
				"left": 126.9,
				"top": 68.13,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: left;\"><span style=\"font-size: 8.16px;font-family: 微软雅黑;font-weight: bold;letter-spacing: 0px;vertical-align: sub; font-size: smaller;\">LOGO&nbsp;HERE</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "shape",
				"id": "XXuSp2EG5k",
				"width": 37.09,
				"height": 49.07,
				"left": 86.27,
				"top": 54.26,
				"viewBox": [
					37.09,
					49.07
				],
				"path": " M12.52585180324682,15.061927760483426 C6.222519928064549,19.74025380730025 0,36.7419752945126 8.081194711772142,42.78956750137337 C16.324013317779723,49.065370734908136 19.798927043841747,29.66743346761887 26.829566443083507,29.21101141427089 C37.09268372703413,28.526378334248914 33.05208637114806,0 12.52585180324682,15.061927760483426z",
				"fill": "none",
				"fixedRatio": false,
				"rotate": 96,
				"outline": {
					"color": "#4472C4",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: left;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "top"
				},
				"flipH": true,
				"flipV": false,
				"special": true
			},
			{
				"type": "shape",
				"id": "dTTR6SvKVl",
				"width": 49.43,
				"height": 64.87,
				"left": 67.25,
				"top": 45.19,
				"viewBox": [
					49.43,
					64.87
				],
				"path": " M16.693029537565977,19.914839315143745 C8.292666286403742,26.10050910242324 0,48.580138329365795 10.769696475849017,56.57624805438564 C21.754786881215015,64.87409776902886 26.38575636583009,39.226198651040704 35.75539229981874,38.622718671793926 C49.43290682414698,37.717498702923756 44.048058586222474,0 16.693029537565977,19.914839315143745z",
				"fill": "#0070c0",
				"fixedRatio": false,
				"rotate": 284,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: left;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "top"
				},
				"flipH": true,
				"flipV": false,
				"special": true
			},
			{
				"type": "line",
				"id": "GEDBOIFEfz",
				"width": 0.5,
				"left": null,
				"top": 172.10000000000002,
				"start": [
					null,
					0
				],
				"end": [
					0,
					218.55
				],
				"style": "solid",
				"color": "#4472C4",
				"points": [
					"",
					""
				]
			},
			{
				"type": "line",
				"id": "guuhFFx_yM",
				"width": 3,
				"left": null,
				"top": 170.8,
				"start": [
					null,
					0
				],
				"end": [
					0,
					64.23
				],
				"style": "solid",
				"color": "#4472C4",
				"points": [
					"",
					""
				]
			},
			{
				"type": "shape",
				"id": "8MVtz01mr_",
				"width": 274.43,
				"height": 75.73,
				"left": 499.01,
				"top": 161.02,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
				"fill": "none",
				"fixedRatio": false,
				"rotate": 0,
				"text": {
					"content": `<p style=\"text-align: right;\"><span style=\"color: #0070C0;font-size: 55.1px;font-family: 微软雅黑;font-weight: bold;letter-spacing: 3.0612244897959187px;\">PART&nbsp;${serial}</span></p>`,
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "top"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "3ei49NTK7h",
				"width": 469.54,
				"height": 75.73,
				"left": 303.9,
				"top": 250.02,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
				"fill": "none",
				"fixedRatio": false,
				"rotate": 0,
				"text": {
					"content": `<p style=\"text-align: right;\"><span style=\"font-size: 55.1px;font-family: 微软雅黑;font-weight: bold;\">${title}</span></p>`,
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "top"
				},
				"flipH": false,
				"flipV": false
			}
		],
		background
	}
}